<template>
  <div class="task">task</div>
</template>
<script>
import { Vue, Component } from 'vue-property-decorator'

@Component({
  name: 'Task'
})
export default class Task extends Vue {}
</script>
<style lang="less" scoped>
.task {
}
</style>
